/**
 * Temporary hotfix for both
 * https://jira.migros.net/browse/IHGWEBCC-2368 - SRP Redesign
 * https://jira.migros.net/browse/IHGWEBCC-2471 - PDP sticky sidebar
 *
 */
export default function useRedesignPageOverflow(mode: 'visible' | 'hidden') {
  const isRedesign = useRedesignFeature()
  const classname =
    mode === 'hidden' ? 'overflow-x-hidden' : 'overflow-x-visible'
  const isEnabled = ref(false)

  function toggleOverflow() {
    if (isRedesign.isEnabled) {
      document.body.classList.toggle(classname)
      isEnabled.value = !isEnabled.value
    }
  }

  onMounted(() => {
    toggleOverflow()
  })

  onBeforeUnmount(() => {
    toggleOverflow()
  })

  return { isEnabled }
}
